export const SMOOTH_ZOOM_COMMAND_INTERVAL_MS = 45;
export const SMOOTH_ZOOM_FRAME_MS = 32;

const decimalPlaces = (value) => {
  const text = String(value);
  return text.includes('.') ? text.split('.')[1].length : 0;
};

export const clampZoom = (value, min, max) => (
  Math.max(min, Math.min(max, Number(value)))
);

export const getNextSmoothZoom = ({ current, target, min, max, step }) => {
  const safeMin = Number.isFinite(Number(min)) ? Number(min) : 1;
  const safeMax = Number.isFinite(Number(max)) ? Number(max) : safeMin;
  const safeStep = Number.isFinite(Number(step)) && Number(step) > 0
    ? Number(step)
    : 0.01;
  const boundedCurrent = clampZoom(current, safeMin, safeMax);
  const boundedTarget = clampZoom(target, safeMin, safeMax);
  const distance = boundedTarget - boundedCurrent;

  if (Math.abs(distance) <= safeStep) return boundedTarget;

  // Ease large movements while always advancing by at least one hardware step.
  // A cap prevents a fast slider drag from turning into a visible zoom jump.
  const delta = Math.max(safeStep, Math.min(0.1, Math.abs(distance) * 0.22));
  const rawNext = boundedCurrent + (Math.sign(distance) * delta);
  const steppedNext = safeMin + (
    Math.round((rawNext - safeMin) / safeStep) * safeStep
  );
  const next = distance > 0
    ? Math.min(steppedNext, boundedTarget)
    : Math.max(steppedNext, boundedTarget);
  const precision = Math.max(2, decimalPlaces(safeStep));
  return Number(clampZoom(next, safeMin, safeMax).toFixed(precision));
};
